import DataVizPage from "components/dataVizPage/DataVizPage";

export default DataVizPage